var React = require('react');

function Mobile (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"#FFF","fillRule":"evenodd"},[React.createElement("path",{"d":"M6.056 8.673H33.5c.583 0 1.056-.365 1.056-.816v-2.04c0-.452-.473-.817-1.056-.817H6.056C5.473 5 5 5.365 5 5.816v2.041c0 .451.473.816 1.056.816zm0 8.164H33.5c.583 0 1.056-.366 1.056-.817v-2.04c0-.451-.473-.817-1.056-.817H6.056c-.583 0-1.056.366-1.056.817v2.04c0 .451.473.817 1.056.817zm0 8.163H33.5c.583 0 1.056-.365 1.056-.816v-2.041c0-.451-.473-.816-1.056-.816H6.056c-.583 0-1.056.365-1.056.816v2.04c0 .452.473.817 1.056.817z","fillRule":"nonzero","key":0}),React.createElement("text",{"fontFamily":"'Open Sans', Arial, sans-serif","fontSize":"10","letterSpacing":"-.455","transform":"translate(4 5)","key":1},React.createElement("tspan",{"x":"1.169","y":"31"},"MENU"))]));
}

Mobile.defaultProps = {"width":"40","height":"40"};

module.exports = Mobile;

Mobile.default = Mobile;
